/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HasSubscriptionResponse } from '../models/HasSubscriptionResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ContributionsSubscriptionsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Check if the organization has giving subscriptions.
     * @returns any OK
     * @throws ApiError
     */
    public givingHasSubscriptions(): CancelablePromise<{
        data: HasSubscriptionResponse;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/contributions/has-subscriptions',
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

}
